import PaymentServicesPaymentMethod from './paymentServices.jsx'
import DirectDepositPaymentMethod from './directDeposit.jsx'
import ChequePaymentMethod from './cheque.jsx'
import MCOWRAPaymentMethod from './mcowra.jsx'
import ElectronicFundsTransferPaymentMethod from './electronicFundsTransfer.jsx'
import EnettPaymentMethod from './enett.jsx'
import SmartMoneyPaymentMethod from './smartMoney.jsx'
import PaymentGatePaymentMethod from './paymentGate.jsx'
import CreditAgreementPaymentMethod from './creditAgreement.jsx'
import PaypalPaymentMethod from './paypal.jsx'
import FakePaymentMethod from './fakePaymentMethod.jsx'
import UnknownPaymentMethod from './unknownPaymentMethod.jsx'

const methods = {
  paymentServices: PaymentServicesPaymentMethod,
  directDeposit: DirectDepositPaymentMethod,
  cheque: ChequePaymentMethod,
  mcowra: MCOWRAPaymentMethod,
  electronicFundsTransfer: ElectronicFundsTransferPaymentMethod,
  eNett: EnettPaymentMethod,
  smartMoney: SmartMoneyPaymentMethod,
  paymentGate: PaymentGatePaymentMethod,
  creditAgreement: CreditAgreementPaymentMethod,
  paypal: PaypalPaymentMethod,
}

if (process.env.BS_ENV === 'test') {
  methods.fake = FakePaymentMethod
  methods.unknown = UnknownPaymentMethod
}

export default methods
